/* eslint-disable react/require-default-props */
import { Menu } from '@headlessui/react';
import Icon from '@mdi/react';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface DropdownButtonProps {
    children: React.ReactNode;
    icon?: string;
    enabled?: boolean;
    active?: boolean;
    className?: string;
    onClick?: () => void;
}

// eslint-disable-next-line react/display-name
const DropdownButton = forwardRef<HTMLButtonElement, DropdownButtonProps>(
    ({ children, icon, enabled = true, className = '', onClick }, ref) => {
        return (
            <Menu.Item disabled={!enabled}>
                {({ active }: { active: boolean }) => (
                    <DropdownButtonPlain
                        ref={ref ?? undefined}
                        enabled={enabled}
                        className={twMerge(
                            active && 'bg-slate-200',
                            !enabled ? 'opacity-50' : '',
                            className,
                        )}
                        onClick={onClick}
                        icon={icon}
                    >
                        {children}
                    </DropdownButtonPlain>
                )}
            </Menu.Item>
        );
    },
);

export const DropdownButtonPlain = forwardRef<
    HTMLButtonElement,
    DropdownButtonProps
>(
    (
        { children, enabled = true, className = '', onClick, icon, active },
        ref,
    ) => (
        <button
            ref={ref ?? undefined}
            disabled={!enabled}
            className={twMerge(
                `text-sm' flex w-full items-center gap-3 rounded-md px-4 py-2 text-left font-semibold leading-5 transition duration-150 ease-in-out hover:bg-slate-200 focus:bg-slate-200 focus:outline-none enabled:active:scale-95`,
                active && 'bg-slate-200',
                !enabled ? 'opacity-50' : '',
                className,
            )}
            onClick={enabled ? onClick : undefined}
        >
            {icon && <Icon path={icon} size={0.8} className="shrink-0" />}
            {children}
        </button>
    ),
);

DropdownButtonPlain.displayName = 'DropdownButtonPlain';

export default DropdownButton;
